import React, { useState } from "react";
import { View, Text, Image, ScrollView } from "react-native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import { AppImages } from "../../../../utility/AppImages";
import { CommonButton } from "../../../../common/CommonButton";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { ActivityIndicator } from "react-native-paper";
import ImageComponent from "../../../../Components/ImageComponent";

const CancelEventDetail = ({
  onCloseClick,
  onConfirm,
  isCancelling,
  accessToken,
  eventID,
  selectedReason,
  message,
  isMobile = false,
  showButtons = true,
  viewers = [],
  totalViewers = 0,
}) => {
  const deviceSize = useDeviceSize();
  const [errorText, setErrorText] = useState(false);

  const avatarSize = isMobile ? 40 : 50;

  return (
    <View
      style={{
        width: isMobile ? "100%" : "40%",
        alignItems: isMobile ? "center" : "flex-start",
        flex: showButtons ? 1 : undefined,
        justifyContent: showButtons ? "space-between" : "flex-start",
      }}
    >
      {/* Top section - Text and Avatars grouped together */}
      <View style={{ alignItems: "center", width: "100%" }}>
        {/* Total Viewers */}
        <Text
          style={{
            ...AppFontStyle.REGULAR_ANYBODY_12,
            color: "rgba(255, 255, 255, 0.5)",
            textAlign: "center",
            marginBottom: 10,
            width: "100%",
          }}
        >
          Total Viewers Confirmed: {totalViewers || viewers.length || 0}
        </Text>

        {/* User avatars - show real viewers */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          {viewers.length > 0 ? (
            <View style={{ flexDirection: "row", marginLeft: 10 }}>
              {viewers.slice(0, 7).map((viewer, index) => (
                <View
                  key={index}
                  style={{
                    width: avatarSize,
                    height: avatarSize,
                    borderRadius: avatarSize / 2,
                    backgroundColor: AppColors.lightPurple_604e74,
                    overflow: "hidden",
                    marginLeft: index > 0 ? -10 : 0,
                    borderWidth: 2,
                    borderColor: "#111827",
                  }}
                >
                  {viewer.profilePicture ? (
                    <ImageComponent
                      url={viewer.profilePicture}
                      style={{
                        width: avatarSize,
                        height: avatarSize,
                        resizeMode: "cover",
                      }}
                    />
                  ) : (
                    <View
                      style={{
                        width: avatarSize,
                        height: avatarSize,
                        backgroundColor: AppColors.lightPurple_604e74,
                      }}
                    />
                  )}
                </View>
              ))}
              {viewers.length > 7 && (
                <View
                  style={{
                    width: avatarSize,
                    height: avatarSize,
                    borderRadius: avatarSize / 2,
                    backgroundColor: "#374151",
                    marginLeft: -10,
                    borderWidth: 2,
                    borderColor: "#111827",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text style={{ color: "#FFFFFF", fontSize: 10, fontWeight: "700" }}>
                    +{viewers.length - 7}
                  </Text>
                </View>
              )}
            </View>
          ) : (
            <Image
              source={AppImages.icDummyUserGroup}
              style={{
                height: avatarSize,
                width: isMobile ? 200 : 250,
                resizeMode: "contain",
              }}
            />
          )}
        </View>
      </View>

      {/* Buttons - only show on web */}
      {showButtons && (
        <View style={{ gap: 10, width: "100%" }}>
          <View style={{ flexDirection: "row", gap: 12 }}>
            <CommonButton
              title="Cancel"
              onTap={onCloseClick}
              buttonStyle={{
                flex: 1,
                height: 38,
                paddingHorizontal: 10,
                backgroundColor: "transparent",
                borderWidth: 1,
                borderColor: "#FFFFFF",
                borderRadius: 6,
                shadowOpacity: 0,
                justifyContent: "center",
                alignItems: "center",
              }}
              textStyle={{
                ...AppFontStyle.BOLD_ANYBODY_12,
                color: "#FFFFFF",
              }}
              disabled={isCancelling}
            />

            <CommonButton
              title={isCancelling ? "Cancelling..." : "Confirm Cancellation"}
              onTap={() => {
                onConfirm();
                setErrorText(true);
              }}
              buttonStyle={{
                flex: 1,
                height: 38,
                paddingHorizontal: 10,
                backgroundColor: "#DC2626",
                borderRadius: 6,
                shadowOpacity: 0,
                justifyContent: "center",
                alignItems: "center",
              }}
              textStyle={{
                ...AppFontStyle.BOLD_ANYBODY_12,
                color: "#FFFFFF",
              }}
              disabled={isCancelling}
            />
          </View>

          {isCancelling && (
            <ActivityIndicator
              size="small"
              color="#DC2626"
              style={{ marginTop: 10 }}
            />
          )}

          <View style={{ flexDirection: "row", gap: 12 }}>
            <Text
              style={{
                ...AppFontStyle.REGULAR_ANYBODY_10,
                color: "rgba(255, 255, 255, 0.5)",
                textAlign: "center",
                flex: 1,
              }}
            >
              Keep the event active
            </Text>

            <Text
              style={{
                ...AppFontStyle.REGULAR_ANYBODY_10,
                color: "rgba(255, 255, 255, 0.5)",
                textAlign: "center",
                flex: 1,
              }}
            >
              Cancel event and notify attendees
            </Text>
          </View>
        </View>
      )}

      {/* Error text */}
      {errorText && (
        <View>
          <Text
            style={{
              ...AppFontStyle.BOLD_ANYBODY_12,
              color: "#EF4444",
              marginTop: 10,
            }}
          >
            {!accessToken || !eventID
              ? "Missing required information to cancel event"
              : !selectedReason
                ? "Please select a cancellation reason from the dropdown"
                : selectedReason !== "Other" && message && message.trim() === ""
                  ? "Please provide a valid message or leave it blank"
                  : null}
          </Text>
        </View>
      )}
    </View>
  );
};

export default CancelEventDetail;
